import { tableRangeSettings } from "./table-range-settings";

export const bars = {
	search: "Buscar",
	searchBarPlaceholder: "Buscar por nombre del bar",
	searchProductPlaceholder: "Buscar por producto",
	searchCategoryPlaceholder: "Buscar por categoría de producto",
	manageBar: "Gestionar Bar",
	menuTooltipActive: "Menú vinculado a este bar y activo",
	menuTooltipInactive: "Menú vinculado a este bar e inactivo",
	emptyMessage: "Sin elementos para mostrar",
	addBar: "Agregar bar",
	editBar: "Editar bar",
	yesDeleteBar: "Sí, eliminar bar",
	deleteMessage:
		"La eliminación impactará la operación: los productos dejarán de ser mostrados y las impresoras serán desasociadas. Esta acción no puede deshacerse. ¿Desea continuar?",
	delete: "Eliminar",
	cancel: "Cancelar",
	deleteBar: "Eliminar Bar",
	stock: "Inventario:",
	printerIps: "IP de la impresora",
	kds: "Kds",
	activeProducts: "Productos Activos",
	inactiveProducts: "Productos Inactivos",
	notifications: {
		productActivated: "Producto activado con éxito",
		productDeactivated: "Producto desactivado con éxito",
	},
	transfer: {
		noItems: "Ningún elemento disponible",
		noCategoryFound: 'Ninguna categoría encontrada para "{{category}}"',
		noProductFound: 'Ningún producto encontrado para "{{product}}"',
		noResultsFound:
			'Ningún resultado encontrado para categoría "{{category}}" y producto "{{product}}"',
		selectProductsToActivate: "Seleccionar productos para activar",
		selectProductsToDeactivate: "Seleccionar productos para desactivar",
		inactiveProductTooltip:
			"Este producto no está activo en el lugar y no estará disponible para venta en el PDV ni será impreso en pedidos de delivery",
	},
	modal: {
		barName: "Nombre del bar",
		barStock: "Inventario",
		addNewIp: "Agregar IP de impresora (Opcional)",
		printerType: "Tipo",
		printerOffline: "Offline",
		numberOfLanes: "Cant de vías",
		numberOfLanesDescription:
			"Cantidad de vías impresas en la impresora después del pedido.",
		menu: "Menú",
		logoFicha: "Logo de la ficha",
		logoFichaInfo:
			"Si no selecciona un logo para ficha en el bar, el logo impreso en la ficha será el de {{placeName}}",
		logoFichaDescription: "Imagen que aparecerá impresa en la ficha.",
		stockDescription: "El inventario seleccionado será utilizado por este bar.",
		menuDescription: "El menú seleccionado será utilizado por este bar.",
		barNamePlaceholder: "Ingrese el nombre del bar",
		barStockPlaceholder: "Seleccione",
		menuPlaceholder: "Seleccione uno o más menús",
		saveModifiedBar: "Guardar cambios",
		addBar: "Agregar bar",
		errors: {
			printerTypeRequired: "El campo tipo de impresora es obligatorio",
			printerNameRequired: "Campo nombre obligatorio",
			printerStockRequired: "Campo inventario obligatorio",
			printerIpFormat: "El campo de IP debe ser válido ej: 192.168.1.1",
			pagesToPrintMin: "El campo N° de vías debe ser de mínimo {{min}}",
			pagesToPrintMax: "El campo N° de vías debe ser máximo {{max}}",
			validIp: "El campo de ip debe ser válido",
			requiredField: "Campo obligatorio",
			maxLength: "El campo debe tener máximo {{max}} caracteres",
			pagseguroFieldsRequired: "Complete los datos de Pagseguro",
		},
		addImage: "Agregar Imagen",
		fileTypeInfo: "Tipo de archivo: jpeg, pjpeg, png",
		multiEc: {
			alertTitle: "Atención",
			warning:
				"Todas las terminales vinculadas a este bar transaccionarán con los datos informados. ¡Información incorrecta puede impedir transacciones!",
			placeholder: "Ingrese el",
			pagseguroActivationCode: "Código de Activación Pagseguro",
			checkBox: "Configurar terminales del cliente (EC del cliente)",
		},
	},
	tableRangeSettings,
};
